export default __webpack_public_path__ + "static/media/vector.05f5058b.svg";